import SectionPermissionsContext from '../contexts/SectionPermissionsContext';
import { useContext } from 'react';
import { SectionPermissionsContextValue } from '../types/Context';

const useSectionPermissions = (): SectionPermissionsContextValue => {
    const context = useContext(SectionPermissionsContext);

    if (!context) {
        throw new Error('useSectionPermissions must be used within an AssistantsPermissionsProvider');
    }

    return context;
};

export default useSectionPermissions;